import React, { useContext, useState } from 'react';

export interface SelectedEventContextValue {
    selectedEventId: string | null;
    setSelectedEventId: React.Dispatch<React.SetStateAction<string | null>>;
}

export interface SelectedEventProviderProps {
    children: React.ReactNode;
    initialSelectedEventId?: string;
}

export interface SelectedEventContext {
    SelectedEventProvider: (props: SelectedEventProviderProps) => React.ReactElement;
    useSelectedEvent: () => SelectedEventContextValue;
}

export function createSelectedEventContext(): SelectedEventContext {
    const context = React.createContext<SelectedEventContextValue | null>(null);

    function SelectedEventProvider(props: SelectedEventProviderProps) {
        const { children, initialSelectedEventId = null } = props;
        const [selectedEventId, setSelectedEventId] = useState<string | null>(
            initialSelectedEventId
        );

        return (
            <context.Provider value={{ selectedEventId, setSelectedEventId }}>
                {children}
            </context.Provider>
        );
    }

    function useSelectedEvent(): SelectedEventContextValue {
        const value = useContext(context);

        if (!value) {
            throw new Error('useAnnotation must be used within a AnnotationProvider');
        }

        return value;
    }

    return { SelectedEventProvider, useSelectedEvent };
}
